import { gql } from '@apollo/client'

import { CHAT_USER_TOKEN_FRAGMENT } from './fragments'

export const RETRIEVE_CHAT_USER_REFRESH_TOKEN = gql`
  mutation retrieveChatUserToken {
    retrieveChatUserToken {
      ...ChatUserTokenFields
    }
  }
  ${CHAT_USER_TOKEN_FRAGMENT}
`
